export default __webpack_public_path__ + "static/media/39_desktop.e8d16559.jpeg";